import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ScrollerModule } from 'primeng/scroller';
import { NotificationsResponse } from '../models/notification/notificationResponse';
import { NotificationsRequest } from '../models/notification/notificationRequest';
import { TimeAgoPipe } from "../pipe/time-ago.pipe";
import { MessageTemplate } from '../models/enums/enums';
import { AdditionalInformation } from '../models/enums/additionalInformation';
import { NotificationFactoryService } from '../services/notification/notification-factory.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
interface LazyEvent {
  first: number;
  last: number;
}

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [ScrollerModule, TimeAgoPipe, CommonModule, RouterModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit {
  notifications: NotificationsResponse[] = [];
  lazyLoading: boolean = false;
  first: number = 0;
  constructor(
    private notificationService: NotificationFactoryService) {

  }

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.notificationService.getNotiifications({
      pageNumber: 1,
      pageSize: 10
    }).subscribe({
      next: (response) => {
        this.notifications = Array.from({ length: response.total });
      },
      error: (err) => {
        console.error('Error loading notifications', err);
        this.lazyLoading = false;
      }
    });
  }

  onLazyLoad($event: LazyEvent) {
    
    this.lazyLoading = true;
    var { last } = $event;
    const request = {
      pageNumber: this.first == 0 ? this.first : Math.floor(this.first / 10) + 1,
      pageSize: last - this.first
    };

    this.notificationService.getNotiifications(request).subscribe({
      next: (response) => {
        // Ensure notifications array is initialized and has enough space
        if (!this.notifications) {
          this.notifications = [];
        }

        for (let i = 0; i < response.result.length; i++) {
          let item = response.result[i];
          if (item.data && typeof item.data === 'string') {
            try { item.data = JSON.parse(item.data as any); } catch(e){}
          }
          this.notifications[this.first + i] = item;
        }
        this.first = last; // Update the first index for the next load
        this.lazyLoading = false;
      },
      error: (err) => {
        console.error('Error loading notifications', err);
        this.lazyLoading = false;
      }
    });
  }


  getRoute(notification: NotificationsResponse): string {
    if (notification?.data?.['routing']) {
      return notification.data['routing']['Route'] || notification.data['routing']['route'] || '';
    }
    return '';
  }
}
